import { downloadFromBlob } from "@/utils/downloadUtils";
import type {
  AccountRef,
  AiConversationDetail,
  AiStep,
  Outcome,
} from "./aiConversationsTypes";

export const conversationTypeLabels: Record<string, string> = {
  cancel_contract_chat: "Cancellation chat",
  cancel_contract_analysis: "Cancellation analysis",
  bulk_buy_chat: "Bulk buy chat",
  bulk_buy_analysis: "Bulk buy analysis",
  buy_contract_chat: "Buy contract chat",
  buy_contract_analysis: "Buy contract analysis",
  send_transfer_chat: "Send chat",
  send_file_analysis: "Send analysis",
  ppa_contract_chat: "PPA chat",
  ppa_contract_analysis: "PPA analysis",
  ecolabel_device_chat: "Ecolabel device chat",
  ecolabel_statement_chat: "Ecolabel statement chat",
  ecolabel_device_extraction: "Ecolabel extraction",
  ecolabel_device_matching: "Ecolabel matching",
  consumption_readings_chat: "Consumption readings chat",
};
export const conversationTypeLabel = (type: string) =>
  conversationTypeLabels[type] ?? type;
export const outcomePill = (outcome: Outcome) => ({
  label: {
    complete: "Complete",
    incomplete: "Incomplete",
    rejected: "Rejected",
    replied: "Replied",
    unknown: "Outcome unknown",
    empty: "Empty",
  }[outcome],
  className: {
    complete: "bg-success-subtle text-success-emphasis",
    incomplete: "bg-warning-subtle text-warning-emphasis",
    rejected: "bg-danger-subtle text-danger-emphasis",
    replied: "bg-info-subtle text-info-emphasis",
    unknown: "bg-warning-subtle text-warning-emphasis",
    empty: "bg-secondary-subtle text-secondary-emphasis",
  }[outcome],
});
export const stepPill = (step: AiStep | null) =>
  ({
    relevance_check: "Relevance check",
    extraction: "Extraction",
    merge: "Merge",
    reply: "Reply",
    rejection: "Rejection",
    unclassified: "Unclassified",
  })[step ?? "unclassified"];
export function buildGcpLogsUrl(conversation: AiConversationDetail): string {
  const query = `resource.type="k8s_container"\nresource.labels.cluster_name="soldera-production"\nresource.labels.namespace_name="soldera"\njsonPayload.conversation_id="${conversation.id}"`;
  const at = conversation.created_at;
  return `https://console.cloud.google.com/logs/query;query=${encodeURIComponent(query)};cursorTimestamp=${encodeURIComponent(at)};duration=PT30M;aroundTime=${encodeURIComponent(at)}?project=soldera-production`;
}
export function exportConversationJson(detail: AiConversationDetail): void {
  downloadFromBlob(
    JSON.stringify(detail, null, 2),
    `ai-conversation-${detail.id}.json`,
    "application/json"
  );
}
export const initialsFor = (account: AccountRef) =>
  (account.name || account.email)
    .split(/[ .@_-]+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
